import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits
   * Cart buttons are always managed client-side, never server-disabled
   * Harper & Grant: minus stays enabled at the minimum, where it removes the line (decreaseQuantity)
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const effectiveMax = this.getEffectiveMax();
    const { value } = this.getCurrentValues();

    // Cart buttons are always dynamically managed
    minusButton.disabled = false;
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }

  /**
   * Harper & Grant: minus at the minimum quantity removes the line, the same way as the trash icon
   * (cart-items-component onLineItemRemove), instead of doing nothing.
   * @param {Event} event - The event.
   */
  decreaseQuantity(event) {
    const { min, value } = this.getCurrentValues();
    const line = Number(this.refs.quantityInput.dataset.cartLine);
    const cartItems = this.closest('cart-items-component');

    if (value <= min && line && cartItems && 'onLineItemRemove' in cartItems) {
      event.preventDefault();
      /** @type {any} */ (cartItems).onLineItemRemove(line);
      return;
    }

    super.decreaseQuantity(event);
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
